import { ReservationDataService } from '@/common/services/details/details.service';
import { crpInternational } from '@/core/domain/car-rental-policy/models/crp-body';
import { DetailsInterface } from '@/core/domain/details/models/details.model';
import { GtmPurchaseUseCase } from '@/core/domain/gtm/usecases/gtmPurchase.usecase';
import { GtmReservationCompleteUseCase } from '@/core/domain/gtm/usecases/gtmReservationComplete.usecase';
import { ClearReservationUseCase } from '@/core/domain/reservation/usecases/clearReservation.usecase';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs';

@Component({
    selector: 'fe-step-5',
    templateUrl: './step-5.component.html',
    styleUrls: ['./step-5.component.scss'],
})
export class Step5Component implements OnInit, OnDestroy {
    id: string | null = '';
    reservationDetails: DetailsInterface | null = null;

    public crpInternational?: crpInternational;

    breadcrumbs = [
        { label: 'fe_breadcrumb_view_cancel', url: 'check-your-reservation' },
        {
            label: 'fe_breadcrumb_details',
            url: 'reservations/reservation-complete',
        },
    ];

    constructor(
        private readonly reservationDataService: ReservationDataService,
        private readonly route: ActivatedRoute,
        private readonly gtmPurchaseUseCase: GtmPurchaseUseCase,
        private readonly gtmReservationComplete: GtmReservationCompleteUseCase,
        private readonly clearReservationUseCase: ClearReservationUseCase,
    ) {}

    ngOnInit(): void {
        this.id = this.route.snapshot.queryParamMap.get('reservationCode');
        const lastName = this.route.snapshot.queryParamMap.get('lastName');
        this.reservationDataService
            .fetchDetails({
                reservationCode: this.id as string,
                lastName: lastName as string,
            })
            .subscribe((details) => {
                this.reservationDetails = details;
                if (
                    details.data !== undefined &&
                    details.data.reservationDetails.currency !== 'MXN'
                ) {
                    this.crpInternational = {
                        stationId:
                            details.data.reservationDetails.branchPickup.id,
                        pickup: details.data.reservationDetails.pickupDate,
                        return: details.data.reservationDetails.returnDate,
                    };
                }
            });
        this.gtmPurchaseUseCase.execute(this.id as string).subscribe();
        this.gtmReservationComplete
            .execute(this.id as string)
            .pipe(switchMap(() => this.clearReservationUseCase.execute()))
            .subscribe();
    }

    ngOnDestroy(): void {
        this.reservationDataService.clearDetailsCache();
    }
}
